const alertsRelations = { forbids: 'forbids', requires: 'requires' };
const alertsLevels = { info: 'info', error: 'error' };

export { alertsRelations, alertsLevels };
